// 客户管理
const map = {
  customerCards: () => import('@/views/customer/CustomerCards'),
  customerInfo: () => import('@/views/customer/CustomerInfo'),
  surnamesList: () => import('@/views/customer/SurnamesList'),
  oakCrmLabel: () => import('@/views/customer/oakCrmLabel'), // crm客户标签
  labelManage: () => import('@/views/customer/labelManage'), // 标签管理
  crmPayment: () => import('@/views/customer/CrmPayment') // crm 红包用户
}

export default map
